let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fCrOi")).then(() => parcelRequire('1PpzE'));